import { render, staticRenderFns } from "./ProjectFileDrawer.vue?vue&type=template&id=4a3c438b&scoped=true"
import script from "./ProjectFileDrawer.vue?vue&type=script&lang=js"
export * from "./ProjectFileDrawer.vue?vue&type=script&lang=js"
import style0 from "./ProjectFileDrawer.vue?vue&type=style&index=0&id=4a3c438b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3c438b",
  null
  
)

export default component.exports